import { ReactComponent as SmallerLogoIcon } from "assets/images/secondary-logo.svg";
import { TEST_IDS } from "modules/common/constants/TestIds";

export function Logo() {
  return <SmallerLogoIcon data-testid={TEST_IDS} height={28} width={60} />;
}
